import stateOptions from '../options/state';

export default {
  name: {
    value: '',
    error: null,
    name: 'name',
    placeholder: 'Name',
    breed: 'input',
    touched: false,
    isRequired: true,
    validationType: null,
    hasBlurred: false,
    inputType: 'text',
  },
  primary_color: {
    value: '',
    error: null,
    name: 'primary_color',
    placeholder: 'Primary Color',
    breed: 'input',
    touched: false,
    isHalf: true,
    isRequired: true,
    validationType: 'color',
    hasBlurred: false,
    inputType: 'text',
  },
  secondary_color: {
    value: '',
    error: null,
    name: 'secondary_color',
    placeholder: 'Secondary Color',
    breed: 'input',
    isHalf: true,
    pullRight: true,
    touched: false,
    isRequired: true,
    validationType: 'color',
    hasBlurred: false,
    inputType: 'text',
  },
  address1: {
    value: '',
    error: null,
    name: 'address1',
    placeholder: 'Address',
    breed: 'input',
    touched: false,
    isRequired: true,
    validationType: null,
    hasBlurred: false,
    inputType: 'text',
  },
  address2: {
    value: '',
    error: null,
    name: 'address2',
    placeholder: 'Alternate Address',
    breed: 'input',
    touched: false,
    isRequired: false,
    validationType: null,
    hasBlurred: false,
    inputType: 'text',
  },
  city: {
    value: '',
    error: null,
    name: 'city',
    placeholder: 'City',
    breed: 'input',
    touched: false,
    isRequired: true,
    validationType: null,
    hasBlurred: false,
    inputType: 'text',
  },
  state: {
    value: '',
    error: null,
    name: 'state',
    placeholder: 'State',
    breed: 'select',
    touched: false,
    isRequired: true,
    validationType: null,
    hasBlurred: false,
    inputType: 'text',
    options: stateOptions,
    displayValue: '',
    isActive: false
  },
  country: {
    value: '',
    error: null,
    name: 'country',
    placeholder: 'Country',
    breed: 'input',
    touched: false,
    isRequired: true,
    validationType: null,
    hasBlurred: false,
    inputType: 'text',
  },
  postal_code: {
    value: '',
    error: null,
    name: 'postal_code',
    placeholder: 'Zip',
    breed: 'input',
    touched: false,
    isRequired: true,
    validationType: null,
    hasBlurred: false,
    inputType: 'text',
  },
  latitude: {
    value: '',
    error: null,
    name: 'latitude',
    placeholder: 'Latitude',
    breed: 'input',
    touched: false,
    isHalf: true,
    isRequired: true,
    validationType: 'number',
    hasBlurred: false,
    inputType: 'number',
    },
  longitude: {
    value: '',
    error: null,
    name: 'longitude',
    placeholder: 'Longitude',
    breed: 'input',
    isHalf: true,
    pullRight: true,
    touched: false,
    isRequired: false,
    validationType: 'number',
    hasBlurred: false,
    inputType: 'number',
  },
  phone: {
    value: '',
    error: null,
    name: 'phone',
    placeholder: 'Phone',
    breed: 'input',
    touched: false,
    isRequired: true,
    validationType: 'phone',
    hasBlurred: false,
    inputType: 'text',
  },
  welcome_message: {
    value: '',
    error: null,
    name: 'welcome_message',
    placeholder: 'Welcome Message Displayed on Tablet',
    breed: 'textarea',
    touched: false,
    isRequired: true,
    validationType: null,
    hasBlurred: false,
    inputType: 'textarea',
		charLimit: 50
  },
}



/** WEBPACK FOOTER **
 ** ./src/forms/location/create.js
 **/